module.exports = __webpack_public_path__ + "static/media/loader.e8b8e682.svg";